import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { ShortcutBinding } from '../../proxy/models/shortcut-binding';
import { PAGE_SHORTCUTS } from '../global/constants/page-shortcut';

@Injectable({
  providedIn: 'root',
})
export class ShortcutService {
  private router = inject(Router);
  private currentPageShortcutSubject = new BehaviorSubject<ShortcutBinding | null>(null);
  public currentPageShortcut = this.currentPageShortcutSubject.asObservable();

  private customShortcutSubject = new Subject<ShortcutBinding>();
  public customShortcut$: Observable<ShortcutBinding> = this.customShortcutSubject.asObservable();

  private shortcuts: ShortcutBinding[] = Object.values(PAGE_SHORTCUTS);
  private chordActive = false;
  private chordTimeout: any;

  public setCurrentPageShortcut(shortcut: ShortcutBinding | null): void {
    this.currentPageShortcutSubject.next(shortcut);
  }

  public handleKeydown(event: KeyboardEvent): void {
    const target = event.target as HTMLElement;
    if (
      target &&
      (['INPUT', 'TEXTAREA', 'BUTTON'].includes(target.tagName) ||
        target.isContentEditable)
    ) {
      return;
    }

    const key = event.key.toLowerCase();
    const isMac = navigator.platform.toUpperCase().includes('MAC');
    const primaryModifier = isMac ? event.metaKey : event.ctrlKey;

    if (primaryModifier && key === 'k') {
      event.preventDefault();
      event.stopPropagation();

      this.chordActive = true;

      clearTimeout(this.chordTimeout);
      this.chordTimeout = setTimeout(() => this.chordActive = false, 500);
      return;
    }

    if (this.chordActive) {
      for (const shortcut of this.shortcuts) {
        if (key === shortcut.key.toLowerCase()) {
          event.preventDefault();
          event.stopPropagation();

          this.chordActive = false;
          clearTimeout(this.chordTimeout);

          if (shortcut.target && shortcut.action === 'navigate') {
            this.router.navigateByUrl(shortcut.target);
            break;
          } else if (shortcut.action === 'custom') {
            this.customShortcutSubject.next(shortcut);
            break;
          }
        }
      }
    }
  }
}
